import React from 'react';
import propTypes from 'prop-types';
import AddProductButton from './AddProductButton';
import TotalsTable from './TotalsTable';

function Footer({ items }) {
  const calculateTotalTax = (quantity, rate, tax) => {
    return quantity * rate * (tax / 100).toFixed(4);
  };

  const calculateTotal = (quantity, rate, tax) => {
    return quantity * rate + calculateTotalTax(quantity, rate, tax);
  };

  const totals = {
    tax: items.reduce(
      (acc, e) =>
        acc + calculateTotalTax(+e.quantity, +e.price_before_tax, +e.tax_rate),
      0
    ),
    total: items.reduce(
      (acc, e) =>
        acc + calculateTotal(+e.quantity, +e.price_before_tax, +e.tax_rate),
      0
    ),
  };

  return (
    <tfoot>
      <tr
        className="table__footer"
        style={{
          '--footer-areas':
            items.length > 0
              ? `"add-item totals-labels totals"`
              : `"add-item add-item add-item"`,
        }}
      >
        <AddProductButton length={items.length} />
        {items.length !== 0 && <TotalsTable totals={totals} />}
      </tr>
    </tfoot>
  );
}

Footer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  items: propTypes.array.isRequired,
};

export default Footer;
